// AILogic.js

/**
 * DESTEKMALDESTEK V3.0 (GEMINI ENTEGRASYONLU)
 * Artık regex yok, saf zeka var.
 */

export const generateAIResponse = async (input, context) => {
    try {
        const response = await fetch('/api/chat', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                message: input,
                context: {
                    score: context.score,
                    champ: context.champ,
                    isGameOver: context.isGameOver,
                    isPaused: context.isPaused
                }
            }),
        });

        const data = await response.json();
        return data.reply;

    } catch (error) {
        console.error("AI Bağlantı Hatası:", error);
        return "Bağlantı koptu brom, ama sen oynamaya devam et.";
    }
};